<div
  #toastContainer
  class="mzic-popover mzic-popover--fixed-c-bottom style-toast medium {{
    toastClass
  }} toast-dismissible">
  <div>
    <mzic-svg [src]="iconPath" [class]="iconClass" />
    <div class="message-container">
      <div class="toast-message">
        {{ message }}
      </div>
    </div>
  </div>
</div>
